import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import copy from "copy-to-clipboard";
import { Toast } from "antd-mobile";
import { getCookie, getBaseUrl } from "../../util";
import "./index.scss";

interface IProps {
    myCode: string;
    onClose: () => void;
    onOpenSharePic: () => void;
}

interface IState {}

// 分享下载
class InvietDownLoadModal extends BaseComponent<IProps, IState> {
    onCopy = (text: string) => {
        copy(text);
        Toast.show("复制链接成功", 3, true);
    };

    render() {
        const { myCode, onClose, onOpenSharePic } = this.props;
        const code = myCode || "";
        const shareUrl = `${getBaseUrl()}?code=${code}`;
        return (
            <div className="invite-download-modal">
                <div className="invite-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="invite-box">
                        <div className="share-link">{shareUrl}，打开链接下载游戏，即可参与活动获得皮肤哦</div>
                        <div className="code-box">
                            <div className="code-text">您的邀请码</div>
                            <div className="code-vale">{code}</div>
                        </div>
                        <div className="share-des">*好友领取「宁琴·暖夜」皮肤即可成功完成邀请，请不要变更手机号，否则邀请失效。</div>
                        <div className="btn-link" onClick={() => this.onCopy(`${shareUrl}，打开链接下载游戏，即可参与活动获得皮肤哦`)}></div>
                        <div className="btn-pic" onClick={onOpenSharePic}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InvietDownLoadModal;
